const row1 = [
  { src: "clients/adulmecatorii.png", alt: "Adulmecătorii" },
  { src: "clients/anacora.png", alt: "Farmacia Anacora" },
  { src: "clients/albota.png", alt: "Complex Turistic Albota" },
  { src: "clients/ancoora.webp", alt: "Ancoora" },
  { src: "clients/incoplus.png", alt: "Inco+" },
  { src: "clients/city3d.svg", alt: "City3d" },
  { src: "clients/hanulvatra.png", alt: "Hanul Vatra" },
];

const row2 = [
  { src: "clients/mariancotoi.png", alt: "Saloanele Marian Cotoi" },
  { src: "clients/oculovision.png", alt: "OculoVision" },
  { src: "clients/vitalberry.png", alt: "Vital Berry" },
  { src: "clients/zaopark.svg", alt: "Zao Park" },
  { src: "clients/yolosolo.png", alt: "YoloSolo" },
  { src: "clients/rasub.png", alt: "Rasub Construct", invert: true },
];

export default function ClientsCarousel() {
  return (
    <section data-testid="clients-section" className="py-16 lg:py-20 overflow-hidden">
      <div className="section-container">
        <div className="text-center mb-10">
          <p className="text-xs tracking-[0.2em] uppercase font-bold text-[#0F2942]/40 mb-3">Au incredere in noi</p>
          <h2 className="font-['Outfit'] text-xl sm:text-2xl tracking-tight font-semibold text-[#1A1D20]">
            Companii care și-au pus site-ul pe mâini bune
          </h2>
        </div>
      </div>
      <div className="relative">
        <div className="flex gap-12 animate-[scroll-left_40s_linear_infinite]" style={{width: "max-content"}}>
          {[...Array(3)].flatMap((_, rep) => row1.map((c, i) => (
            <div key={`r1-${rep}-${i}`} className="flex items-center justify-center h-16 px-2 shrink-0">
              <div className="client-logo-bg rounded-xl px-4 py-3 flex items-center justify-center">
                <img src={`${import.meta.env.BASE_URL}images/${c.src}`} alt={c.alt} className="max-h-10 max-w-[130px] object-contain" loading="lazy" />
              </div>
            </div>
          )))}
        </div>
        <div className="flex gap-12 mt-8 animate-[scroll-right_40s_linear_infinite]" style={{width: "max-content"}}>
          {[...Array(3)].flatMap((_, rep) => row2.map((c, i) => (
            <div key={`r2-${rep}-${i}`} className="flex items-center justify-center h-16 px-2 shrink-0">
              <div className="client-logo-bg rounded-xl px-4 py-3 flex items-center justify-center">
                <img src={`${import.meta.env.BASE_URL}images/${c.src}`} alt={c.alt} className={`max-h-10 max-w-[130px] object-contain${c.invert ? " invert" : ""}`} loading="lazy" />
              </div>
            </div>
          )))}
        </div>
      </div>
    </section>
  );
}
